/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-04 13:54:59
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-05 16:26:16
 * @FilePath: /chaoyongtuan/src/api/tagManagement.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

// 标签列表
export const getTagList = params => {
	return request({
		url: '/micro-cyt/tag/page',
		data: params,
		method: AjaxMethod.post,
	});
};

// 标签批量保存或更新
export const saveOrUpdateTag = params => {
	return request({
		url: '/micro-cyt/tag/batch-save-or-update',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 批量删除
export const batchDelTag = params => {
	return request({
		url: '/micro-cyt/tag/batch-del',
		data: params,
		method: AjaxMethod.post,
	});
};
